<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Standard Risk Text Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.txtRef }}</td>
                  <td class="text-xs-left">{{ row.item.txtTitle }}</td>
                  <td class="text-xs-center">
                    <v-btn icon color="primary" text type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Standard Risk Text Reference No.', value: 'txtRef' },
        { text: 'Standard Risk Text Line', value: 'txtTitle' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiUrl = this.menu.stdRiskTextList
      const expand = { busCls: this.busClass }
      if (apiUrl) {
        this.items = []
        this.loading = true
        this.$http
          .get(expandURI(apiUrl, expand))
          .then((result) => {
            const { data } = result.data.stdItemTxtList
            if (data) {
              data.map((itemText) => {
                const itemTextList = {
                  txtRef: itemText.stdRiskTxtRef,
                  txtTitle: itemText.stdRiskTxtLn
                }
                this.items.push(itemTextList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSelect(data) {
      const textObj = {
        txtRef: data.txtRef,
        txtTitle: data.txtRef + ' - ' + data.txtTitle
      }
      this.$emit('selectStdRiskTxt', textObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.underwriting.policyRiskItemSettings.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    busClass: String
  }
}
</script>

<style>
</style>
